import { useState } from "react";
import { AmenityPropType } from "./type";
const Amenity = (props: AmenityPropType) => {
  const {
    icon,
    name,
    src: initialSrc
  } = props;
  const [src, setSrc] = useState(initialSrc);
  return <div className='flex w-full items-center gap-2 bg-white' data-sentry-component="Amenity" data-sentry-source-file="Amenity.tsx">
      {src && src.length > 0 ? <div className='flex h-8 w-8 min-w-[32px] items-center justify-center rounded-full bg-white p-0 md:bg-grayBorder'>
          <img className='h-4 w-4 opacity-50' src={src} alt={name} width={16} height={16} loading='lazy' fetchPriority='low' decoding='async' onError={() => setSrc(undefined)} />
        </div> : icon}
      <p className='line-clamp-1 text-sm font-medium leading-[1.7] text-Gray-700 md:text-base md:font-normal md:text-grayText'>
        {name}
      </p>
    </div>;
};
export default Amenity;